<template>
  <div class="footer">
    <div class="link" v-if="friends.length>0">
      <div class="main-box">
        <div class="fl link_pr">
          <b style="margin-left:20px">友情链接：</b>
          <a
            href="#"
            v-for="item in friends"
            :key="item.basicId"
            @click.prevent="gotoFriend(item.basicId)"
          >{{item.basicTitle}}</a>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="main-box">
      <div class="clear"></div>
      <!-- <div class="fot_nav">
        <a href="http://www.puxiantech.com">网站首页</a> |
        <a href="http://www.puxiantech.com/html/1/53/133/index.html" rel="dropmenu53">关于我们</a>|
        <a href="http://www.puxiantech.com/html/1/59/68/index.html" rel="dropmenu59">我们的服务</a> |
        <a href="http://www.puxiantech.com/html/1/61/65/index.html" rel="dropmenu61">新闻资讯</a>|
        <a href="http://www.puxiantech.com/html/1/62/index.html">专家风采</a> |
        <a href="http://www.puxiantech.com/html/1/93/94/index.html" rel="dropmenu93">培训动态</a>
        <a href="http://www.puxiantech.com/html/1/19/141/index.html" rel="dropmenu19">联系我们</a>
      </div>-->
      <div class="banquan">
        <div style="color:#fff;text-align:center" v-html="foot"></div>
        <p>
          ©中国热交换器技术公共服务平台 2015-{{new Date().getFullYear()}}
          <a href="http://www.shpqxx.com/" target="_blank">技术支持：上海平衢信息科技</a>
        </p>
        <p>
          <a href="https://beian.miit.gov.cn" target="_blank">陇ICP备09003824号-1</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010502001426" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left:30px">甘公网安备 62010502001426号</a>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      foot: "",
      friends: [],
    };
  },
  created() {
    this.getFoot(this.$store.state.categoryAppid);
    this.getFriends(this.$store.state.categoryAppid);
  },
  computed: {
    ...mapGetters(["getCategoryAppid"]),
  },
  watch: {
    getCategoryAppid(id) {
      this.getFriends(id);
      this.getFoot(id);
    },
  },
  methods: {
    ...mapActions(["getArticle", "findPage"]),
    getFoot(id) {
      console.log(id)
      this.findPage({
        basicCategoryid: 292,
        basicType: id,
        paeg: 1,
        size: 1,
      }).then((res) => {
        // console.log(res);
        if(res.data.dataList.length==1) {
          var articleId = res.data.dataList[0].basicId;
          this.getArticle(articleId).then((res) => {
          this.foot = res.data.articleContent;
        });
        }
      });
    },
    getFriends(id) {
      this.findPage({
        basicCategoryid: 291,
        basicType: id,
        paeg: 1,
        size: 10,
      }).then((res) => {
        // console.log(res);
        this.friends = res.data.dataList;
      });
    },
    gotoFriend(id) {
      this.getArticle(id).then((res) => {
        var url = res.data.articleUrl;
        window.open(url, "_blank");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #018fd7;
  width: 100%;
  height: 200px;
  font-size: 12px;
  color: #3a3737;
  .link {
    border-bottom: 1px solid #3c84d4;
    line-height: 50px;
    margin-bottom: 10px;
    .link_pr {
      width: 930px;
      height: 50px;
      b {
        height: 50px;
        float: left;
        display: block;
        line-height: 50px;
        font-size: 12px;
        color: #fff;
        padding-right: 19px;
      }
      a {
        height: 50px;
        float: left;
        display: block;
        line-height: 50px;
        font-size: 12px;
        color: #fff;
        padding-right: 19px;
        text-decoration: none;
        cursor: pointer !important;
      }
    }
  }
  .main-box {
    clear: both;
    overflow: hidden;
    margin: 0 auto;
    // width: 1200px;
    zoom: 1;
  }
  .fot_nav {
    text-align: center;
    color: #fff;
    a {
      padding: 0 5px;
      line-height: 30px;
      font-size: 12px;
      color: #fff;
      text-decoration: none;
      cursor: pointer !important;
    }
  }
  p {
    text-align: center;
    color: #fff;
    line-height: 30px;
    a {
      color: #fff;
      text-decoration: none;
      cursor: pointer !important;
    }
  }
}
</style>
